import React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from 'i18n/messages'
import { useSelector, useDispatch } from 'react-redux'
import { Spinner, Button, } from 'reactstrap'
import { Currency } from '../components'
import Headroom from 'react-headroom'
import {
  setBookingCode,
  makeSelectBookingCode,
  makeSelectLoading,
  makeSelectItemsQty,
  setManualSeatInfos,
  setStepOneComplete,
  makeSelectManualSeatInfos,
  makeSelectItemsTotal,
  createOrder,
} from 'logic/goods'
import { updateCustomerAttr } from 'logic/customers'

function BasketButtonContent () {
  const total = useSelector(makeSelectItemsTotal())
  const qty = useSelector(makeSelectItemsQty())
  return (
    <>
      {qty
        ? <span className="qty">{qty}</span>
        : null
      }
      <span className="tt-icon tt-icon-shopping-cart" />
      {total
        ? <strong className="currency mr-2"><Currency value={total} /></strong>
        : null
      }
      <span className="checkout-text">
        <FormattedMessage {...messages.checkoutZurKassa} />
      </span>
    </>
  )
}

export default function GoodsBasket () {
  const dispatch = useDispatch()
  const qty = useSelector(makeSelectItemsQty())
  const manualSeatInfos = useSelector(makeSelectManualSeatInfos())
  const loading = useSelector(makeSelectLoading())
  const handleCheckout = () => qty > 0 && dispatch(createOrder())
  const handleChangeBookingCode = () => {
    dispatch(setBookingCode(''))
    dispatch(setStepOneComplete(false))
  }
  const handleChangeManual = () => {
    dispatch(setManualSeatInfos({}))
    dispatch(updateCustomerAttr('ready', false))
    dispatch(setStepOneComplete(false))
  }
  const bookingCode = useSelector(makeSelectBookingCode())
  return (
    <Headroom>
      <div className="container card">
        <div className="booking-code-info">
          <div className="basket-btn-wrap">
            <Button
              color="success"
              disabled={qty < 1}
              className="d-flex align-items-center"
              onClick={handleCheckout}
            >
              {loading
                ? <Spinner color="light" />
                : <BasketButtonContent />
              }
            </Button>
          </div>
          <div className="booking-code-wrap">
            { bookingCode
              ? <>
                  <div className="label">
                    <FormattedMessage {...messages.bookingCode} />
                  </div>
                  <div className="booking-code">
                    <div
                      onClick={handleChangeBookingCode}
                      className="d-flex align-items-center justify-content-end text-right"
                    >
                      <span className="tt-icon tt-icon-pencil mr-2" />
                      <span>{bookingCode}</span>
                    </div>
                  </div>
                </>
              : <>
                  <div className="label">
                    <FormattedMessage {...messages.selectedSeats} />
                  </div>
                  <div className="booking-code">
                    <div
                      onClick={handleChangeManual}
                      className="d-flex align-items-center justify-content-end text-right"
                    >
                      <span className="tt-icon tt-icon-pencil mr-2" />
                      <span>
                        <FormattedMessage {...messages.section} />: {manualSeatInfos.section}
                        <span className="ml-2" />
                        <FormattedMessage {...messages.row} />: {manualSeatInfos.row}
                        <span className="ml-2" />
                        <FormattedMessage {...messages.seat} />: {manualSeatInfos.seat}
                      </span>
                    </div>
                  </div>
                </>
              }
          </div>
        </div>
      </div>
    </Headroom>
  )
}